var map = {
	"./ar.json": 762,
	"./en.json": 763,
	"./localise_stf/ar.json": 360,
	"./localise_stf/en.json": 361,
	"./menu_ar.json": 362,
	"./menu_en.json": 363,
	"./menu_kw_ar.json": 278,
	"./menu_kw_en.json": 279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 761;